import React from 'react';
import { MessageCircle } from 'lucide-react';

const WhatsAppButton = () => {
  const whatsappNumber = '919899313175';
  const message = encodeURIComponent('Hi, I need help with Jai Paras Spares app.');
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${message}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-20 right-5 z-40 flex items-center justify-center w-10 h-10 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-md transition-all duration-300 hover:scale-110 opacity-70 hover:opacity-100"
      data-testid="whatsapp-chat-button"
      title="Chat on WhatsApp"
    >
      <MessageCircle className="w-5 h-5" />
    </a>
  );
};

export default WhatsAppButton;
